export default "__VITE_ASSET__o9r98lxm__"